import { Batch } from '../models/batch';

export interface BatchScore {
  ok: number;
  warning: number;
  error: number;
  total: number;
  score?: number;
}

// Default score shown when a batch has no report yet (1 document, nothing done).
export const EMPTY_BATCH_SCORE: BatchScore = {
  ok: 0,
  warning: 0,
  error: 0,
  total: 1,
};

// derives the aggregate analysis score for a batch
export function computeBatchScore(batch: Batch | undefined): BatchScore {
  if (!batch?.report) return EMPTY_BATCH_SCORE;
  const score = batch.report.score !== undefined
    ? batch.report.score
    : 100 * (batch.report.ok + batch.report.warning * 0.5) / batch.documents;
  return {
    total: batch.documents,
    score,
    ...batch.report,
  };
}
